<div [className]="theme?.root + ' bg-no-repeat bg-center bg-cover'" [style]="theme?.bgImage">
  <div class="container {{ theme.container }}">
    @if (topContent) {
      <div class="wysiwyg py-v-spacing sm:px-v-spacing max-w-container mx-auto bundle__top-content"
      [innerHtml]="topContent"></div>
    }
    <div class="mx-auto" [ngClass]="{ 'w-fit': bundles.length > 1, 'sm:px-v-spacing': bundles.length === 1 }">
      <!-- Mobile View -->
      @if (bundles.length > 1) {
        <div
          [attr.data-coupon-scroll-target]="hasPricedBundle ? couponScrollTarget : null"
          class="gap-x-6 grid grid-cols-1 justify-items-center lg:grid-cols-3 lg:hidden mobile-grid">
          @for (b of bundles; track b; let last = $last; let index = $index) {
            <div class="pt-v-spacing w-full flex flex-col max-w-[366px]"
              [ngClass]="{ 'basic-column': index === 0, 'deluxe-column': index === 1, 'premium-column': index === 2 }">
              <!-- Tier Badge Component -->
              @if (b.topContent) {
                <tier-badge [topContent]="b.topContent" [topContentStyles]="b.topContentStyles"
                [topBackgroundColor]="b.topBackgroundColor" [topTextColor]="b.topTextColor"></tier-badge>
              } @else {
                <!-- Added as blank space to align the card to the bottom when it doesn't have a badge -->
                <span class="h-[38px]">{{ b.topContent }}</span>
              }
              <div class="w-full rounded-t-ace-mode rounded-b-ace-mode bg-white text-vis-regular shadow-card"
                [ngClass]="{ 'rounded-ace-mode': isAceDesign  }">
                <div class="wysiwyg p-v-spacing" [innerHTML]="b.principalContent"></div>
                <div class="w-full pt-0 p-v-spacing">
                  <div [class]="b.savePercentage ? '' : 'invisible'" class="text-xs font-bold text-ace-pink-600">
                    SAVE @if (b.discountType === 'PERCENT') {
                    <span>{{ b.savePercentage }}%</span>
                    }@if (b.discountType === 'FLAT') {
                    <span
                    >${{ b.maxPrice - b.originalPrice }}</span>
                  }
                </div>
                <div>
                  @if (b.maxPrice && b.savePercentage) {
                    <span
                      class="text-lg font-extrabold price-cross-color line-through">${{ CustomDecimal(b.maxPrice)
                    }}</span>
                  }
                  @if (b.originalPrice) {
                    <span class="text-lg font-extrabold ml-1 text-ace-teal-900">${{
                    CustomDecimal(b.originalPrice) }}</span>
                  }
                </div>
                @if (showFee && !b.suppressFee && b.productFees > 0) {
                  <span class="text-sm self-center pl-1.5 product-fee">
                    +
                    <span (click)="activateModal(b.feeModalContent)"
                      class="product-fee-link !mt-0 !font-normal !text-sm !inline">
                      {{feeLabel}}
                    </span>
                  </span>
                }
              </div>
              @if (b.originalPrice >= bnplThreshold) {
                <div class="pb-4 text-xs text-ace-grey-800 px-v-spacing">
                  <span>As low as ${{ b.affirmPrice }}/mo with
                    <img class="inline-block affirm-img" src="https://xgrit-ecom.imgix.net/ace/affirm-logo.svg"
                      alt="Affirm Logo" />
                    †, or<br />
                    4 interest-free payments of ${{ b.klarnaPrice }} with
                    <img class="inline-block klarna-img" src="https://xgrit-ecom.imgix.net/ace/klarna-logo.svg"
                      alt="Klarna Logo" />
                    ††
                  </span>
                </div>
              }
              <div class="w-full pt-0 p-v-spacing items-center">
                <div class="w-full xs:mr-v-spacing lg:mr-0 xl:mr-v-spacing">
                  <vision-button [data]="getButtonData(b)" [className]="'basic-cta_mobile'"></vision-button>
                </div>
                <!-- Button component for Schedule -->
                @if (b.webinarData) {
                  <div class="w-full xs:mr-v-spacing lg:mr-0 xl:mr-v-spacing mt-3 text-center">
                    <button class="tertiary-button v-button" (click)="showWebinarSchedule($event, b.webinarData)">View
                    Schedule</button>
                  </div>
                }
                <div class="w-full mt-2 text-center text-sm cursor-pointer text-vis-subtle" (click)="toggleModal()">
                  @if (!suppressGuarantee(b.product[0])) {
                    <span class="inline-block">{{guaranteeText}}</span>
                  }
                </div>
              </div>
              @if (b.bottomContent) {
                <div class="wysiwyg p-v-spacing w-full mt-4" [innerHTML]="b.bottomContent"></div>
              }
              @if (showAccordion(index)) {
                <div>
                  @for (accordionItem of accordions[index]; track accordionItem; let i = $index) {
                    <div
                      class="border-ace-gray-300 border-t rounded-b-ace-mode">
                      <div class="wrapper">
                        <div class="w-full" [ngClass]="{'border-b border-ace-gray-300': i !== accordions[index].length -1}">
                          <div class="group p-v-spacing item-title flex justify-between items-center cursor-pointer"
                            (click)="toggle(accordionItem)">
                            <div class="title w-full flex flex-row items-center">
                              @if (accordionItem.itemIcon && accordionItem.itemIcon.length > 0) {
                                <img
                                  class="rounded-[6px] mr-3" [src]="accordionItem.itemIcon[0].url"
                                  [alt]="accordionItem.itemIcon[0].alt" width="40" height="40" />
                              }
                              <div class="inline-block align-top">
                                <p class="font-extrabold">{{ accordionItem.itemTitle }}</p>
                                @if (accordionItem.itemValueDescriptor) {
                                  <p class="block mt-0 font-normal">
                                    {{ accordionItem.itemValueDescriptor }}
                                  </p>
                                }
                              </div>
                              @if (accordionItem.itemBadge) {
                                <span
                                  class="badge text-center font-extrabold rounded-[100px] bg-ace-teal-200 text-ace-teal-700 leading-[.8] py-2 px-3 ml-2.5 mr-3 text-sm border-ace-teal-700 border border-solid">{{
                                accordionItem.itemBadge }}</span>
                              }
                            </div>
                            <div class="flex items-center bundle-fa">
                              <div class="icon text-ace-blue-600 group-hover:text-ace-blue-500 text-base text-lg mt-1">
                                @if (!accordionItem.showDescription) {
                                  <div>
                                    <span [innerHTML]="openIcon"></span>
                                  </div>
                                }
                                @if (accordionItem.showDescription) {
                                  <div>
                                    <span [innerHtml]="closeIcon"></span>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                          @if (accordionItem.showDescription) {
                            <div
                              class="p-v-spacing item-description w-full wysiwyg border-t border-ace-gray-300"
                            [innerHTML]="accordionItem.itemDescription"></div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
    <!-- End Mobile View -->
    <!-- Single Bundle Mobile View -->
    @if (bundles.length === 1) {
      <div
        [attr.data-coupon-scroll-target]="hasPricedBundle ? couponScrollTarget : null"
        class="gap-x-6 grid grid-cols-1 justify-items-center md:grid-cols-3 md:hidden mobile-grid">
        @for (b of bundles; track b; let last = $last; let index = $index) {
          <div class="pt-v-spacing w-full flex flex-col max-w-[366px]"
            [ngClass]="{ 'basic-column': index === 0, 'deluxe-column': index === 1, 'premium-column': index === 2 }">
            <!-- Tier Badge Component -->
            @if (b.topContent) {
              <tier-badge [topContent]="b.topContent" [topContentStyles]="b.topContentStyles"
              [topBackgroundColor]="b.topBackgroundColor" [topTextColor]="b.topTextColor"></tier-badge>
            } @else {
              <!-- Added as blank space to align the card to the bottom when it doesn't have a badge -->
              <span class="h-[38px]">{{ b.topContent }}</span>
            }
            <div class="w-full rounded-t-ace-mode rounded-b-ace-mode shadow-card bg-white text-vis-regular"
              [ngClass]="{ 'rounded-ace-mode': isAceDesign  }">
              <div class="wysiwyg p-v-spacing" [innerHTML]="b.principalContent"></div>
              <div class="w-full pt-0 p-v-spacing">
                <div [class]="b.savePercentage ? '' : 'invisible'" class="text-xs font-bold text-ace-pink-600">
                  SAVE @if (b.discountType === 'PERCENT') {
                  <span>{{ b.savePercentage }}%</span>
                  }@if (b.discountType === 'FLAT') {
                  <span
                  >${{ b.maxPrice - b.originalPrice }}</span>
                }
              </div>
              <div>
                @if (b.maxPrice && b.savePercentage) {
                  <span
                    class="text-lg font-extrabold price-cross-color line-through">${{ CustomDecimal(b.maxPrice)
                  }}</span>
                }
                @if (b.originalPrice) {
                  <span class="text-lg font-extrabold ml-1 text-ace-teal-900">${{
                  CustomDecimal(b.originalPrice) }}</span>
                }
                @if (showFee && !b.suppressFee && b.productFees > 0) {
                  <span class="text-sm self-center pl-1.5 product-fee">
                    +
                    <span (click)="activateModal(b.feeModalContent)"
                      class="product-fee-link !mt-0 !font-normal !text-sm !inline">
                      {{feeLabel}}
                    </span>
                  </span>
                }
              </div>
            </div>
            @if (b.originalPrice >= bnplThreshold) {
              <div class="pb-5 text-xs text-ace-grey-800 px-v-spacing">
                <span>As low as ${{ b.affirmPrice }}/mo with
                  <img class="inline-block affirm-img" src="https://xgrit-ecom.imgix.net/ace/affirm-logo.svg"
                    alt="Affirm Logo" />
                  †, or<br />
                  4 interest-free payments of ${{ b.klarnaPrice }} with
                  <img class="inline-block klarna-img" src="https://xgrit-ecom.imgix.net/ace/klarna-logo.svg"
                    alt="Klarna Logo" />
                  ††
                </span>
              </div>
            }
            <div class="w-full pt-0 p-v-spacing items-center">
              <div class="w-full">
                <vision-button [data]="getButtonData(b)" [className]="'basic-cta_mobile'"></vision-button>
              </div>
              <!-- Button component for Schedule -->
              @if (b.webinarData) {
                <div class="w-full mt-3 text-center">
                  <button class="tertiary-button v-button" (click)="showWebinarSchedule($event, b.webinarData)">View
                  Schedule</button>
                </div>
              }
              <div class="w-full mt-3 text-center text-sm cursor-pointer text-vis-subtle" role="button" tabindex="0" (click)="toggleModal()" (keydown.enter)="toggleModal()" (keydown.space)="toggleModal(); $event.preventDefault()">
                @if (!suppressGuarantee(b.product[0])) {
                  <span class="inline-block">{{guaranteeText}}</span>
                }
              </div>
            </div>
            @if (b.bottomContent) {
              <div class="wysiwyg p-v-spacing w-full mt-4" [innerHTML]="b.bottomContent"></div>
            }
            @if (showAccordion(index)) {
              <div>
                @for (accordionItem of accordions[index]; track accordionItem) {
                  <div
                    class="border-ace-gray-300 border-t rounded-b-ace-mode">
                    <div class="wrapper">
                      <div class="w-full border-ace-gray-300">
                        <div class="group p-v-spacing item-title flex justify-between items-center cursor-pointer"
                          (click)="toggle(accordionItem)">
                          <div class="title w-full flex flex-row items-center">
                            @if (accordionItem.itemIcon && accordionItem.itemIcon.length > 0) {
                              <img
                                class="rounded-[6px] mr-3" [src]="accordionItem.itemIcon[0].url"
                                [alt]="accordionItem.itemIcon[0].alt" width="40" height="40" />
                            }
                            <div class="inline-block align-top">
                              <p class="font-extrabold">{{ accordionItem.itemTitle }}</p>
                              @if (accordionItem.itemValueDescriptor) {
                                <p class="block mt-0 font-normal">
                                  {{ accordionItem.itemValueDescriptor }}
                                </p>
                              }
                            </div>
                            @if (accordionItem.itemBadge) {
                              <span
                                class="badge text-center font-extrabold rounded-[100px] bg-ace-teal-200 text-ace-teal-700 leading-[.8] py-2 px-3 ml-2.5 mr-3 text-sm border-ace-teal-700 border border-solid">{{
                              accordionItem.itemBadge }}</span>
                            }
                          </div>
                          <div class="flex items-center bundle-fa">
                            <div class="icon text-ace-blue-600 group-hover:text-ace-blue-500 text-base text-lg mt-1">
                              @if (!accordionItem.showDescription) {
                                <div>
                                  <span [innerHTML]="openIcon"></span>
                                </div>
                              }
                              @if (accordionItem.showDescription) {
                                <div>
                                  <span [innerHtml]="closeIcon"></span>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                        @if (accordionItem.showDescription) {
                          <div
                            class="p-v-spacing item-description w-full wysiwyg border-t border-ace-gray-300"
                          [innerHTML]="accordionItem.itemDescription"></div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
  <!-- End Single Bundle Mobile View -->
  <!--Single Bundle View-->
  @if (bundles.length === 1) {
<div id="bundle" [attr.data-coupon-scroll-target]="hasPricedBundle ? couponScrollTarget : null" [className]="
          'hidden auto-cols-min justify-items-center gap-x-6 md:grid grid-cols-1 justify-items-center md:grid-cols-' +
          bundles.length +
          ' desktop-grid'
        ">
      @for (b of bundles; track b; let last = $last; let index = $index) {
        <div class="pt-v-spacing w-full flex flex-col"
          [ngClass]="{ 'basic-column': index === 0, 'deluxe-column': index === 1, 'premium-column': index === 2 }">
          <!-- Tier Badge Component -->
          @if (b.topContent) {
            <tier-badge [topContent]="b.topContent" [topContentStyles]="b.topContentStyles"
            [topBackgroundColor]="b.topBackgroundColor" [topTextColor]="b.topTextColor"></tier-badge>
          } @else {
            <!-- Added as blank space to align the card to the bottom when it doesn't have a badge -->
            <span class="h-[38px]">{{ b.topContent }}</span>
          }
            <div class="w-full flex flex-col h-full rounded-t-ace-mode bg-white text-vis-regular shadow-card" [ngClass]="{
                'rounded-b-ace-mode': !accordions[0].length,
                'rounded-ace-mode': isAceDesign && accordions[0].length === 0
              }">
            <div class="flex gap-8 pt-[2.5rem]">
              <!-- Content column -->
              <div class="flex-1 min-w-0 flex flex-col">
                <div class="wysiwyg px-v-spacing pt-2 pb-v-spacing" [innerHTML]="b.principalContent"></div>
                @if (b.bottomContent) {
                  <div class="wysiwyg p-v-spacing w-full mt-4" [innerHTML]="b.bottomContent"></div>
                }
              </div>
              <!-- Pricing group -->
              <div class="flex-shrink-0 flex flex-col pr-v-spacing pb-6 min-w-[240px]">
                <div class="pb-3">
                  @if (b.savePercentage) {
                    <div class="text-xs font-bold text-ace-pink-600">
                      SAVE @if (b.discountType === 'PERCENT') {
                      <span>{{ b.savePercentage }}%</span>
                      }@if (b.discountType === 'FLAT') {
                      <span
                      >${{ b.maxPrice - b.originalPrice }}</span>
                    }
                  </div>
                }
                <div class="flex">
                  @if (b.maxPrice && b.savePercentage) {
                    <span
                      class="text-lg font-extrabold price-cross-color line-through decoration-ace-grey-900 text-vis-regular mr-1">${{
                    CustomDecimal(b.maxPrice) }}</span>
                  }
                  @if (b.originalPrice) {
                    <span #bundlePrice class="text-lg font-extrabold text-ace-teal-900">
                    ${{ CustomDecimal(b.originalPrice) }}</span>
                  }
                  @if (showFee && !b.suppressFee && b.productFees > 0) {
                    <span class="text-sm self-center pl-1.5 product-fee">
                      +
                      <span (click)="activateModal(b.feeModalContent)"
                        class="product-fee-link !mt-0 !font-normal !text-sm !inline">
                        {{feeLabel}}
                      </span>
                    </span>
                  }
                  @if (couponApplied) {
                    <span
                      class="coupon-applied text-[13px] font-bold text-ace-pink-600 ml-3 rounded-[30px] mb-[30px] py-[7px] px-[15px] bg-[#d9e7f2]">Coupon
                    Applied!</span>
                  }
                </div>
              </div>
              @if (b.originalPrice >= bnplThreshold) {
                <div class="pb-4 text-xs text-ace-grey-800">
                  <span>As low as ${{ b.affirmPrice }}/mo with
                    <img class="inline-block affirm-img" src="https://xgrit-ecom.imgix.net/ace/affirm-logo.svg"
                      alt="Affirm Logo" />
                    †, or<br />
                    4 interest-free payments of ${{ b.klarnaPrice }} with
                    <img class="inline-block klarna-img" src="https://xgrit-ecom.imgix.net/ace/klarna-logo.svg"
                      alt="Klarna Logo" />
                    ††
                  </span>
                </div>
              }
              <div class="w-full pt-1">
                <vision-button [data]="getButtonData(b)" [className]="'basic-cta_desktop'"></vision-button>
              </div>
              <!-- Button component for Schedule -->
              @if (b.webinarData) {
                <div class="w-full mt-3 text-center">
                  <button class="tertiary-button v-button" (click)="showWebinarSchedule($event, b.webinarData)">{{
                  viewScheduleLabel }}</button>
                </div>
              }
              <div class="w-full mt-3 text-center text-sm cursor-pointer text-vis-subtle" role="button" tabindex="0" (click)="toggleModal()" (keydown.enter)="toggleModal()" (keydown.space)="toggleModal(); $event.preventDefault()">
                @if (b.product[0] && !suppressGuarantee(b.product[0])) {
                  <span class="inline-block">{{guaranteeText}}</span>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
<!--Single Bundle Accordion-->
@if (bundles.length === 1) {
<div [className]="
          'hidden md:grid grid-cols-1 justify-items-center md:grid-cols-' +
          accordions[0].length +
          ' accordion-desktop-grid rounded-b-ace-mode shadow-card'
        ">
    @for (accordionItem of accordions[0]; track accordionItem; let last = $last; let index = $index) {
      <div class="pt-0 w-full flex flex-col bg-white"
        [ngClass]="{'border-r': index < accordions[0].length - 1, 'rounded-bl-ace-mode': index === 0, 'rounded-br-ace-mode': index === accordions[0].length - 1}">
        <div
          class="desktop-accordion w-full bg-white text-vis-regular border-ace-gray-300 border-t rounded-b-ace-mode -mt-[1px]">
          @if (showAccordion(0)) {
            <div>
              <div class="wrapper">
                <div class="w-full border-ace-gray-300">
                  <div class="group p-v-spacing item-title flex justify-between items-center border-b">
                    <div class="title w-full flex flex-row items-center">
                      @if (accordionItem.itemIcon && accordionItem.itemIcon[0] && accordionItem.itemIcon[0].url) {
                        <img
                          class="inline-block mr-4" [src]="accordionItem.itemIcon[0].url"
                          [alt]="accordionItem.itemIcon[0].altText ? accordionItem.itemIcon[0].altText : ''" width="40"
                          height="40" />
                      }
                      <div class="inline-block align-top">
                        <p class="font-extrabold">{{ accordionItem.itemTitle }}</p>
                        @if (accordionItem.itemValueDescriptor) {
                          <p class="block mt-0 font-normal">
                            {{ accordionItem.itemValueDescriptor }}
                          </p>
                        }
                      </div>
                      @if (accordionItem.itemBadge) {
                        <span
                          class="badge text-center text-sm font-extrabold rounded-[100px] bg-ace-teal-200 text-ace-teal-700 leading-[.8] py-2 px-3 ml-2.5 mr-3 border-ace-teal-700 border border-solid">{{
                        accordionItem.itemBadge }}</span>
                      }
                    </div>
                  </div>
                  <div class="p-v-spacing item-description w-full wysiwyg border-ace-gray-300"
                  [innerHTML]="accordionItem.itemDescription"></div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
<!-- End Single Bundle View -->
<!-- Desktop View -->
@if (bundles.length > 1) {
<div id="bundle" [attr.data-coupon-scroll-target]="hasPricedBundle ? couponScrollTarget : null" [className]="
          'hidden auto-cols-min justify-items-center gap-x-6 lg:grid grid-cols-1 justify-items-center lg:grid-cols-' +
          bundles.length +
          ' desktop-grid'
        ">
    @for (b of bundles; track b; let last = $last; let index = $index) {
      <div class="pt-v-spacing w-full flex flex-col max-w-[366px]"
        [ngClass]="{ 'basic-column': index === 0, 'deluxe-column': index === 1, 'premium-column': index === 2 }">
        <!-- Tier Badge Component -->
        @if (b.topContent) {
          <tier-badge [topContent]="b.topContent" [topContentStyles]="b.topContentStyles"
          [topBackgroundColor]="b.topBackgroundColor" [topTextColor]="b.topTextColor"></tier-badge>
        } @else {
          <!-- Added as blank space to align the card to the bottom when it doesn't have a badge -->
          <span class="h-[38px]">{{ b.topContent }}</span>
        }
            <div class="w-full flex flex-col h-full rounded-t-ace-mode shadow-card bg-white text-vis-regular" [ngClass]="{
                'rounded-b-ace-mode': !accordions[0].length,
                'rounded-ace-mode': isAceDesign && accordions[0].length === 0
              }">
          <div class="wysiwyg p-v-spacing" [innerHTML]="b.principalContent"></div>
          <div class="flex flex-col h-full justify-end">
            <div class="w-full pt-0 pb-4 p-v-spacing">
              <div [class]="b.savePercentage ? '' : 'invisible'" class="text-xs font-bold text-ace-pink-600">
                SAVE @if (b.discountType === 'PERCENT') {
                <span>{{ b.savePercentage }}%</span>
                }@if (b.discountType === 'FLAT') {
                <span
                >${{ b.maxPrice - b.originalPrice }}</span>
              }
            </div>
            <div class="flex">
              @if (b.maxPrice && b.savePercentage) {
                <span
                  class="text-lg font-extrabold price-cross-color line-through decoration-ace-grey-900 text-vis-regular mr-1">${{
                CustomDecimal(b.maxPrice) }}</span>
              }
              @if (b.originalPrice) {
                <span #bundlePrice class="text-lg font-extrabold text-ace-teal-900">
                ${{ CustomDecimal(b.originalPrice) }}</span>
              }
              @if (showFee && !b.suppressFee && b.productFees > 0) {
                <span class="text-sm self-center pl-1.5 product-fee">
                  +
                  <span (click)="activateModal(b.feeModalContent)"
                    class="product-fee-link !mt-0 !font-normal !text-sm !inline">
                    {{feeLabel}}
                  </span>
                </span>
              }
              @if (couponApplied) {
                <span
                  class="coupon-applied text-[13px] font-bold text-ace-pink-600 ml-3 rounded-[30px] mb-[30px] py-[7px] px-[15px] bg-[#d9e7f2]">Coupon
                Applied!</span>
              }
            </div>
          </div>
          @if (b.originalPrice >= bnplThreshold) {
            <div class="pb-4 text-xs text-ace-grey-800 px-v-spacing">
              <span>As low as ${{ b.affirmPrice }}/mo with
                <img class="inline-block affirm-img" src="https://xgrit-ecom.imgix.net/ace/affirm-logo.svg"
                  alt="Affirm Logo" />
                †, or<br />
                4 interest-free payments of ${{ b.klarnaPrice }} with
                <img class="inline-block klarna-img" src="https://xgrit-ecom.imgix.net/ace/klarna-logo.svg"
                  alt="Klarna Logo" />
                ††
              </span>
            </div>
          }
          <div class="w-full pt-0 p-v-spacing items-center">
            <div class="w-full xs:mr-v-spacing lg:mr-0 xl:mr-v-spacing">
              <vision-button [data]="getButtonData(b)" [className]="'basic-cta_desktop'"></vision-button>
            </div>
            <!-- Button component for Schedule -->
            @if (b.webinarData) {
              <div class="w-full xs:mr-v-spacing lg:mr-0 xl:mr-v-spacing mt-3 text-center">
                <button class="tertiary-button v-button" (click)="showWebinarSchedule($event, b.webinarData)">{{
                viewScheduleLabel }}</button>
              </div>
            }
            <div class="w-full mt-2 text-center text-sm cursor-pointer text-vis-subtle" (click)="toggleModal()">
              @if (b.product[0] && !suppressGuarantee(b.product[0])) {
                <span class="inline-block">
                  {{guaranteeText}}
                </span>
              }
            </div>
            @if (viewScheduleLabel && !b.webinarData) {
              <div class="w-full xs:mr-v-spacing lg:mr-0 xl:mr-v-spacing mt-3 text-center"
                >
                <span class="tertiary-button v-button"></span>
              </div>
            }
          </div>
          @if (b.bottomContent) {
            <div class="wysiwyg p-v-spacing w-full mt-4" [innerHTML]="b.bottomContent"></div>
          }
        </div>
      </div>
    </div>
  }
</div>
}
@if (bundles.length > 1 && (accordions[0]?.length > 0 || accordions[1]?.length > 0 || accordions[2]?.length > 0)) {
  <div
        [className]="
          'hidden gap-x-6 lg:grid grid-cols-1 justify-items-center lg:grid-cols-' +
          bundles.length +
          ' accordion-desktop-grid'
        ">
    @for (b of bundles; track b; let last = $last; let index = $index) {
      <div class="pt-0 w-full flex flex-col max-w-[366px]">
        <div
          class="desktop-accordion w-full shadow-card bg-white text-vis-regular border-ace-gray-300 border-t rounded-b-ace-mode -mt-[1px]">
          @if (showAccordion(index)) {
            <div>
              @for (accordionItem of accordions[index]; track accordionItem; let i = $index) {
                <div>
                  <div class="wrapper">
                    <div class="w-full" [ngClass]="{'border-b border-ace-gray-300': i !== accordions[index].length -1}">
                      <div class="group p-v-spacing item-title flex justify-between items-center cursor-pointer"
                        (click)="toggle(accordionItem)">
                        <div class="title w-full flex flex-row items-center">
                          @if (accordionItem.itemIcon && accordionItem.itemIcon[0] && accordionItem.itemIcon[0].url) {
                            <img
                              class="inline-block mr-4" [src]="accordionItem.itemIcon[0].url"
                              [alt]="accordionItem.itemIcon[0].altText ? accordionItem.itemIcon[0].altText : ''"
                              width="40" height="40" />
                          }
                          <div class="inline-block align-top">
                            <p class="font-extrabold">{{ accordionItem.itemTitle }}</p>
                            @if (accordionItem.itemValueDescriptor) {
                              <p class="block mt-0 font-normal">
                                {{ accordionItem.itemValueDescriptor }}
                              </p>
                            }
                          </div>
                          @if (accordionItem.itemBadge) {
                            <span
                              class="badge text-center text-sm font-extrabold rounded-[100px] bg-ace-teal-200 text-ace-teal-700 leading-[.8] py-2 px-3 ml-2.5 mr-3 border-ace-teal-700 border border-solid">{{
                            accordionItem.itemBadge }}</span>
                          }
                        </div>
                        <div class="flex items-center bundle-fa">
                          <div class="icon text-ace-blue-600 group-hover:text-ace-blue-500 text-base text-lg mt-1">
                            @if (!accordionItem.showDescription) {
                              <div>
                                <span [innerHTML]="openIcon"></span>
                              </div>
                            }
                            @if (accordionItem.showDescription) {
                              <div>
                                <span [innerHtml]="closeIcon"></span>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                      @if (accordionItem.showDescription) {
                        <div
                          class="p-v-spacing item-description w-full wysiwyg border-t border-ace-gray-300"
                        [innerHTML]="accordionItem.itemDescription"></div>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
}
<!-- End Desktop View -->
</div>
@if (hasBnplEligibleProducts) {
  <div class="bnpl-disclaimer mt-8 sm:px-v-spacing">
    <div class="flex">
      <div class="bullet">†</div>
      <div>
        <p>
          Payment options are offered by Affirm and are subject to an eligibility check. Options depend on your
          purchase amount, and a down payment may be required. CA residents: Loans by Affirm Loan Services, LLC are
          made or arranged pursuant to a California Finance Lender license. For licenses and disclosures, see
          <a target="_blank" href="https://www.affirm.com/licenses">affirm.com/licenses</a>.
        </p>
      </div>
    </div>
    <div class="flex">
      <div class="bullet">††</div>
      <div>
        <p>
          See Klarna payment
          <a href="https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_us/sliceitinx"
          target="_blank">terms</a>. A higher initial payment may be required for some consumers. CA resident loans
          made or arranged pursuant
          to a California Financing Law license.
        </p>
      </div>
    </div>
  </div>
}
</div>
</div>

@if (showModal) {
  <div class="fixed inset-0 bg-vis-dark/50 z-50 flex justify-center items-center">
    <div class="w-3/4 lg:w-1/4 bg-white text-vis-regular shadow-md py-v-spacing px-v-spacing relative rounded">
      <div class="font-bold mb-v-spacing flex justify-between cursor-pointer">
        <div class="mr-1">{{guaranteeModalTitle}}</div>
        <fa-icon (click)="toggleModal()" [icon]="faTimes"></fa-icon>
      </div>
      <div>
        {{guaranteeModalBody}}
      </div>
    </div>
  </div>
}
